import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {getActualStripeIntent} from 'utils/getStripePaymentIntent'
import {ORDER_HEADERS} from './orderHeaders'

export const useConfirmOrderApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({order, orderIntent}: Params.ConfirmOrder) => {
      let cardPayment

      if (order.cardPayment && order.cardPayment.gateway === 'stripe') {
        const stripeIntent = getActualStripeIntent(order)

        if (stripeIntent.type === 'paymentIntent') {
          cardPayment = {
            amount: stripeIntent.amount,
            currency: stripeIntent.currency,
            gateway: 'stripe',
            stripe: {
              paymentIntent: stripeIntent.id,
            },
          }
        } else {
          cardPayment = {
            gateway: 'stripe',
            stripe: {
              setupIntent: stripeIntent.id,
            },
          }
        }
      }

      if (order.cardPayment && order.cardPayment.gateway === 'adyen' && order.cardPayment.adyen.session) {
        cardPayment = {
          gateway: 'adyen',
          adyen: {
            sessionId: order.cardPayment.adyen.session.id,
          },
        }
      }

      const {data} = await ventrata.post<Ventrata.Order>(
        `/orders/${order.id}/confirm`,
        {
          contact: orderIntent.contact,
          cardPayment,
        },
        {
          headers: ORDER_HEADERS,
        }
      )

      return data
    },
    [ventrata]
  )
}
